(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire4a54"];
var parcelRegister = parcelRequire.register;
parcelRegister("dVBw1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $a23db30c082f39bd$export$2e2bcd8739ae039; });
class $a23db30c082f39bd$export$2e2bcd8739ae039 {
    constructor(element){
        this.element = element;
        this.links = this.element.querySelectorAll('a');
        this.offset = 20; // 20px offset
    }
    init() {
        //console.log('DocumentIndex observer initialized');
        this.links.forEach((link)=>{
            link.addEventListener('click', this.handleLinkClick.bind(this));
        });
    }
    handleLinkClick(event) {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) this.scrollToTarget(targetElement);
    }
    scrollToTarget(targetElement) {
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - this.offset;
        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
    }
    destroy() {
        console.log('DocumentIndex observer destroyed');
        this.links.forEach((link)=>{
            link.removeEventListener('click', this.handleLinkClick.bind(this));
        });
    }
}

});

})();
//# sourceMappingURL=DocumentIndex.ac3f8a5c.js.map
